import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
//   apiKey: "your-api-key",
//   authDomain: "your-auth-domain",
//   projectId: "your-project-id",
//   storageBucket: "your-storage-bucket",
//   messagingSenderId: "your-messaging-sender-id",
//   appId: "your-app-id",
  apiKey: "AIzaSyAZWDnbkCfLd6Pk2kcnjinT5ayxs600jgM",
  authDomain: "viryawildlife-c92c3.firebaseapp.com",
  projectId: "viryawildlife-c92c3",
  storageBucket: "viryawildlife-c92c3.firebasestorage.app",
  messagingSenderId: "272424787692",
  appId: "1:272424787692:web:e609f0e1a71435e6014fc9",
  measurementId: "G-J9EWE1GX1X"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export { signInWithPopup, RecaptchaVerifier, signInWithPhoneNumber };
const storage = getStorage(app);

export { storage };